// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_9AA","cls2":"DebugPage-cls2_gXR DebugPage-cls1_9AA"};